import { createFileRoute } from '@tanstack/react-router'

import { KnowledgeElementCard } from '@/features/knowledge/components/knowledge-element-card'
import { useCopy } from '@/lib/copy/use-copy'
import { useKnowledge } from '@/lib/copy/use-knowledge'

export const Route = createFileRoute('/wiedza/zywiol')({
  component: WiedzaZywiol,
})

function WiedzaZywiol() {
  const { shell } = useCopy()
  const { data, isLoading, isError } = useKnowledge()
  const k = shell.knowledge

  return (
    <section className="space-y-4 p-5">
      <a
        href="/wiedza"
        className="font-mono text-hint tracking-[1.3px] text-element-ink-mute uppercase"
      >
        &larr; {k.categoryBackLabel}
      </a>
      <div>
        <h1 className="font-display text-[28px] leading-[1.05] text-element-ink italic">
          {k.sectionElements}
        </h1>
        <p className="mt-1 text-hint text-element-ink-dim">
          {k.categoryElementsCount} wpisów · {k.categoryElementsHint}
        </p>
      </div>

      {isLoading && <p className="text-hint text-element-ink-dim">Ladowanie...</p>}
      {isError && (
        <p className="text-hint text-red-400">
          Nie udalo sie pobrac danych. Odswiez strone.
        </p>
      )}

      {data && (
        <div className="space-y-2">
          {data.knowledge.elements.map((e) => (
            <a key={e.id} href={`/wiedza/zywiol/${e.id}`} className="block">
              <KnowledgeElementCard entry={e} />
            </a>
          ))}
        </div>
      )}
    </section>
  )
}
